export const { incidentHasArrestee } = require('./incIncidentHelper');
